module.exports = __webpack_public_path__ + "img/oriental-bg-xxl.67734d3.webp";